import { useMemo } from "react"
import { useAppDispatch } from "hooks/redux"
import { tradeSlice, type TradeItem } from "../store/trade-slice"
import { useDashboardId } from "../context/dashboard-id"
import type { Filter, TradedPosition, TradedPositionField } from "../context/types"
import type { AssetViewGroupBy } from "connected-components/asset-view/templates/types"

export function useTradeActions() {
  const dashboardId = useDashboardId()
  const dispatch = useAppDispatch()

  return useMemo(() => ({
    addTrade: (trade: TradeItem) =>
      dispatch(tradeSlice.actions.addTrade({ dashboardId, trade })),
    resetTrades: () =>
      dispatch(tradeSlice.actions.resetTrades({ dashboardId })),
    setTradedPosition: (tradedPosition: TradedPosition | null, tradedPositionField: TradedPositionField) =>
      dispatch(tradeSlice.actions.setTradedPosition({ dashboardId, tradedPosition, tradedPositionField })),
    setExpanded: (isExpanded: boolean) =>
      dispatch(tradeSlice.actions.setExpanded({ dashboardId, isExpanded })),
    updateTradeFilters: (filter: Filter) =>
      dispatch(tradeSlice.actions.updateTradeFilters({ dashboardId, filter })),
    setAssetViewGroupBy: (assetViewGroupBy: AssetViewGroupBy | null) =>
      dispatch(tradeSlice.actions.setAssetViewGroupBy({ dashboardId, assetViewGroupBy })),
  }), [dispatch, dashboardId])
}
